// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__gA4ON","logoContainer":"Logo_logoContainer__SGtjQ"};